/**
 * Leading "HOID" label, with any whitespace that follows it.
 *
 * Anchored to the start rather than stripped globally: an offer id is numeric, so
 * a leading match is the only real case (the user pasting the "HOID 9001" the
 * table shows them), and a global strip would silently mangle any other term.
 */
const HOID_PREFIX = /^hoid\s*/i;

/**
 * Turns what the user typed into the value sent as the `search` query param: the
 * bare offer id, with the displayed "HOID " label and any surrounding whitespace
 * removed.
 *
 * The table renders `HOID 9001` while the column holds `9001`, so the label has
 * to come off somewhere. Doing it here means the API only ever receives the
 * number and its predicate can match the column directly.
 *
 * Returns "" for a blank term, a whitespace-only term, or a bare "hoid" — all of
 * which the adapters send as `undefined`, i.e. no filter.
 */
export const normalizeSearchTerm = (raw: string): string =>
  raw.trim().replace(HOID_PREFIX, "").trim();
